import type { Components, ItemProps } from 'react-virtuoso';

export interface IListSemanticsContext {
	setSize: number;
	positionOffset: number;
}

const Item = ({ item, context, ...props }: ItemProps<unknown> & { context?: IListSemanticsContext }) => {
	const position = (context?.positionOffset ?? 0) + props['data-index'] + 1;
	const isListItem = !context || position <= context.setSize;

	return (
		<div
			{...props}
			role={isListItem ? 'listitem' : 'none'}
			aria-setsize={isListItem ? context?.setSize : undefined}
			aria-posinset={isListItem ? position : undefined}
		/>
	);
};

// role="list" goes on the Virtuoso scroller, so screen readers don't scroll to the tall inner list
export const listSemanticsComponents: Components<any, IListSemanticsContext> = { Item };
